import nextId from "react-id-generator"
import drmartens7 from "../../images/drmartens7.png"
import drmartens9 from "../../images/drmartens9.png"
import drmartens29 from "../../images/drmartens29.png"
import drmartens21 from "../../images/drmartens21.png"

export const newBoots = [
    {
        id: nextId(),
        image: drmartens7,
        title: "dr martens boots",
        price: "from £99.99"
    },
    {
        id: nextId(),
        image: drmartens9,
        title: "dr martens boots",
        price: "from £99.99"
    },
    {
        id: nextId(),
        image: drmartens29,
        title: "dr martens boots",
        price: "from £99.99"
    },
    {
        id: nextId(),
        image: drmartens21,
        title: "dr martens boots",
        price: "from £99.99"
    },
   
]